import { Statistiche } from './statistiche';

export class Giocatori extends Statistiche {
    public id: number = null;
    public nome: string = null;
    public number: number = null;
    public status: string = null;
    public sub: number = 0;
    public sostituisce: number = null;
    public sostituitoDa: number = null;
    public titolare: boolean = null;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/giocatori.ts